import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.4242 9.94724c1.4499 0 2.6253-1.17537 2.6253-2.62526s-1.1754-2.62526-2.6253-2.62526c-1.4499 0-2.6252 1.17537-2.6252 2.62526s1.1753 2.62526 2.6252 2.62526zM9.79292 14.8534c-.15717-.1022-.60919-.7039-1.84645-3.6669L5.30031 4.84082H.950684L7.30939 20.1921c.01362.0329.03667.061.06624.0808.02957.0198.06434.0304.09992.0304.03558.0001.07038-.0104.10001-.0301.02963-.0197.05276-.0477.06647-.0806l2.18544-5.232c.0072-.0191.0077-.0401.00142-.0596-.00627-.0195-.01895-.0363-.03597-.0476zM16.0955 11.1865c1.2373 2.963 1.6893 3.5647 1.8465 3.6669.017.0113.0297.0281.0359.0476.0063.0195.0058.0405-.0014.0596l-2.1854 5.232c-.0137.0329-.0369.0609-.0665.0806-.0296.0197-.0644.0302-.1.0301-.0356 0-.0704-.0106-.0999-.0304-.0296-.0198-.0526-.0479-.0663-.0808L9.09973 4.84082h4.34967l2.6461 6.34568z",
    fill: "currentColor"
  }));
});